import axios from 'axios';
import React, { useState, useEffect } from 'react';

import styled from 'styled-components'
import { Flex, Text, Spinner } from "../../../../components";
import { Modal, ModalContainer, ModalButton, Input, Select, Label, TextArea } from "../../components";
import { NotificationContainer, NotificationManager } from 'react-notifications';

const Content = styled(Flex)`
  padding: 0 30px;
`;

const HeaderRow = styled(Flex)`
  border-bottom: 1px solid #414568;
  padding: 18px 24px;
  margin-bottom: 24px;
  color: #7178B2;
  font-weight: 600;
  font-size: 12px;
`;

const ItemHeading = styled(Text.Body)`
  font-size: 14px;
  font-weight: 600;
  margin-bottom: 16px;
`;

const Grid = styled.div`
  width: 100%;
  display: grid;
  grid-gap: 20px;
  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
`;

const Item = styled(Flex)`
  flex-direction: column;
  border: 1px solid #414568;
  border-radius: 6px;
  padding: 20px;
  height: fit-content;
`;

const Downloads = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [windowsFile, setWindowsFile] = useState(null);
  const [macFile, setMacFile] = useState(null);

  useEffect(() => {
    axios
      .get('/api/admin/downloads')
      .then(res => {
          setWindowsFile(res.data.windowsFile);
          setMacFile(res.data.macFile);
          setIsLoading(false);
      })
      .catch(err => {
        console.error(err);
      });
  }, []);  

  if (isLoading) return (
    <Spinner></Spinner>
  );

  const openFileInput = (id) => {
    document.getElementById(id).click()
  }

  const uploadFile = (event) => {
    if (event.target.files.length > 0) {
      const file = event.target.files[0];
      let formData = new FormData();
      formData.append("os", event.target.name);
      formData.append("file", file);

      axios({
        method: 'POST',
        url: '/api/admin/downloads/upload-download-file',
        data: formData,
      }).then(res => {
          setWindowsFile(res.data.windowsFile);
          setMacFile(res.data.macFile);
          setIsLoading(false);
      });

    }
  }

  return (
    <>
      <Content dir="column" w='100%'>
        <Flex h="24px" />
        <Grid>
          <Item>
            <ItemHeading>Windows</ItemHeading>
            <Text.Body><span style={{ color: '#7178B2' }}>Current File : {windowsFile.download.file}</span></Text.Body>
            <Flex h="16px" />
            <Text.Body><span style={{ color: '#7178B2' }}>GC Storage Exists : {windowsFile.fileExists ? "Yes" : "No" }</span></Text.Body>
            <Flex h="16px" />
            <Flex w='100%'>
              <ModalButton w='100%' bg="#8A45FF" onClick={() => openFileInput('windowsFile')}>Change File</ModalButton>
              <Input type="file" display="none" id="windowsFile" name="win" onChange={(e) => uploadFile(e)}></Input>
            </Flex>
          </Item>
          <Item>
            <ItemHeading>MAC</ItemHeading>
            <Text.Body><span style={{ color: '#7178B2' }}>Current File : {macFile.download.file}</span></Text.Body>
            <Flex h="16px" />
            <Text.Body><span style={{ color: '#7178B2' }}>GC Storage Exists : {macFile.fileExists ? "Yes" : "No" }</span></Text.Body>
            <Flex h="16px" />
            <Flex w='100%'>
              <ModalButton w='100%' bg="#8A45FF" onClick={() => openFileInput('macFile')}>Change File</ModalButton>
              <Input type="file" display="none" id="macFile" name="mac"  onChange={(e) => uploadFile(e)}></Input>
            </Flex>
          </Item>
        </Grid>
      </Content>

    </>
  )

}

export default Downloads;
